import { apiFetch } from '~/utils/apiFetch'
import type { SiteSupportDto } from '~/types/api/site'

/**
 * GET /api/v1/site/support — 客服入口。
 *
 * 不加 skipAuth：已登录时要带上 Bearer，链接里才有玩家身份（游客照样能调）。
 * skipErrorToast：取不到只是不显示客服按钮，不打扰玩家。
 */
export function fetchSiteSupport() {
  return apiFetch<SiteSupportDto>('/site/support', {
    skipErrorToast: true,
  })
}
